/* eslint-disable react/require-default-props */
import React from 'react';
import { Text } from '../../../atoms/Text/Text';
import './SectionHeaderStyles.scss';
const BASE_CLASS = 'qmb-ui-section-header';
/**
 * SectionHeader Component
 * Displays a section title with a horizontal divider line and optional action buttons.
 * Based on the workspace section__title pattern.
 * @version 1.0.0
 * @since 2026-04-14
 */
export function SectionHeader({ title, actions, sticky = false }) {
    const className = [BASE_CLASS, sticky ? `${BASE_CLASS}--sticky` : ''].filter(Boolean).join(' ');
    return (React.createElement("div", { className: className },
        React.createElement(Text, { variant: "label-large", as: "h3", className: `${BASE_CLASS}__title` }, title),
        actions && React.createElement("div", { className: `${BASE_CLASS}__actions` }, actions)));
}
